/*
 * Copyright (C) 2017-2019 Dremio Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export default {
  hljs: {
    display: "block",
    overflowX: "auto",
    padding: "0.5em",
    marginTop: 0,
    lineHeight: "20px",
    background: "#white",
    color: "var(--text--primary)",
    fontFamily: "var(--dremio--font-family--monospace)",
    fontSize: "14px",
    fontWeight: "400",
    fontFeatureSettings: '"zero" on',
  },
  "hljs-attr": {
    fontWeight: "400",
    color: "var(--text--primary)",
    fontFamily: "var(--dremio--font-family--monospace)",
  },
  "hljs-code": {
    fontFamily: "var(--dremio--font-family--monospace)",
    fontStyle: "italic",
    fontWeight: "400",
  },
  "hljs-emphasis": {
    fontStyle: "italic",
  },
  "hljs-tag": {
    color: "#62c8f3",
  },
  "hljs-variable": {
    color: "#ade5fc",
  },
  "hljs-template-variable": {
    color: "#ade5fc",
  },
  "hljs-selector-id": {
    color: "#ade5fc",
  },
  "hljs-selector-class": {
    color: "#ade5fc",
  },
  "hljs-string": {
    color: "#077d82",
    fontFamily: "var(--dremio--font-family--monospace)",
  },
  "hljs-bullet": {
    color: "#d36363",
  },
  "hljs-type": {
    color: "#ffa",
  },
  "hljs-title": {
    color: "#ffa",
  },
  "hljs-section": {
    color: "#ffa",
  },
  "hljs-attribute": {
    color: "#ffa",
    fontFamily: "var(--dremio--font-family--monospace)",
  },
  "hljs-quote": {
    color: "#ffa",
  },
  "hljs-built_in": {
    color: "#ffa",
  },
  "hljs-builtin-name": {
    color: "#ffa",
  },
  "hljs-number": {
    color: "#d36363",
  },
  "hljs-symbol": {
    color: "#d36363",
  },
  "hljs-keyword": {
    color: "#fcc28c",
  },
  "hljs-selector-tag": {
    color: "#fcc28c",
  },
  "hljs-literal": {
    color: "#fcc28c",
  },
  "hljs-comment": {
    color: "#888",
  },
  "hljs-deletion": {
    color: "#white",
    backgroundColor: "#fc9b9b",
  },
  "hljs-regexp": {
    color: "#c6b4f0",
  },
  "hljs-link": {
    color: "#c6b4f0",
  },
  "hljs-meta": {
    color: "#fc9b9b",
  },
  "hljs-addition": {
    backgroundColor: "#a2fca2",
    color: "#white",
  },
};
